"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Address = void 0;
const Address = {
    dwelling_number: {
        label: 'Dwelling Number',
        type: 'String',
        editable: true,
    },
    street_name: {
        label: 'Street Name',
        type: 'String',
        editable: true,
    },
    suburb: {
        type: 'String',
        editable: true,
    },
    city: {
        type: 'String',
        editable: true,
    },
    country: {
        type: 'String',
        editable: true,
    },
    post_code: {
        label: 'Post Code',
        type: 'String',
        editable: true,
    },
};
exports.Address = Address;
